import React from "react";
import { makeStyles } from "@material-ui/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { connectPagination } from "react-instantsearch-dom";
import { Pagination as MuiPagination } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  pagination: {
    display: "flex",
    justifyContent: "center"
  }
}));

const Pagination = props => {
  const classes = useStyles();
  const { currentRefinement, nbPages, refine } = props;
  const smallScreen = useMediaQuery("(max-width:600px)");

  return (
    <div className={classes.pagination}>
      <MuiPagination
        page={currentRefinement}
        count={nbPages}
        size={smallScreen ? "small" : "medium"}
        onChange={(_, value) => refine(value)}
      />
    </div>
  );
};

export default connectPagination(Pagination);
